import "./App.css";
import { Routes, Route } from "react-router-dom";
import Contact from "./components/contact_details/Contact";
import Start from "./components/Start";
// import { useDispatch } from "react-redux";
// import { useEffect } from "react";
// import { loadPortfolio } from "./redux/action";

function App() {
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(loadPortfolio());
  // }, [dispatch]);
  return (
    <>
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </>
  );
}

export default App;
